/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../../widgets/livewidget/nls/StringResources',
	'../../../../lib/@waca/dashboard-common/dist/api/ContentActionsProviderAPI',
	'../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'jquery'
], (StringResources, ContentActionsProviderAPI, APIFactory, $) => {
	class HideShowSummariesAction {
		constructor(features) {
			this._features = features;
		}

		getContentActionList(idList) {
			let contribution = [];

			if (this._getSelectedContent(idList)) {
				const contentId = idList[0];
				const content = this._features['Canvas'].getContent(contentId);
				const summaryIcon = this._features['Icons'].getIcon('dashboard-hideshowsummaries');
				if (this._supportAction(content)) {
					contribution = [{
						name: 'hideShowSummaries',
						label: this._getLabel(content),
						className: 'hideShowSummariesBtnToggle',
						icon: summaryIcon.id,
						section: ContentActionsProviderAPI.ACTION_SECTION.SELECTION_VIZ_FORMAT,
						order: 20,
						actions: {
							apply: this.execute.bind(this, content)
						},
						type: 'Button'
					}];
				}
			}

			return contribution;
		}

		_supportAction(content) {
			let isAllowed = false;
			const uiState = this._features['DashboardState'].getUiState();
			const visualization = content.getFeature('Visualization');
			if (visualization && !uiState.eventGroups) {
				let visId = visualization.getDefinition().getId();
				let mappingComplete = visualization.getSlots().isMappingComplete();

				isAllowed = mappingComplete && (visId === 'crosstab' || visId === 'JQGrid');
			}

			return isAllowed;
		}

		_getLabel(content) {
			const hideSummaries = content.getPropertyValue('hideSummaries');
			return hideSummaries ? StringResources.get('showSummariesLabel') : StringResources.get('hideSummariesLabel');
		}

		_getSelectedContent(idList) {
			return idList.length === 1;
		}

		execute(content, event) {
			let currentValue = !content.getPropertyValue('hideSummaries');
			content.setPropertyValue('hideSummaries', currentValue);

			const $hideShowSummariesBtn = $(event.currentTarget).find('.hideShowSummariesBtnToggle').addBack();
			const label = this._getLabel(content);
			const span = $hideShowSummariesBtn.find('span');
			if (span) {
				span.text(label);
			}
		}

		getAPI() {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [ContentActionsProviderAPI]);
			}
			return this._api;
		}
	}

	return HideShowSummariesAction;
});
